var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.settings.enabled)?_c('el-button',{staticStyle:{"width":"100%"},attrs:{"icon":"el-icon-camera","type":"info","plain":"","size":"mini","disabled":_vm.loading,"loading":_vm.loading},on:{"click":_vm.handleClick}},[_vm._v("Zoom meeting")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }